import React, { useState } from "react";
import { BenefitCard } from "./BenefitCard";
import { ModalBenefitDetail } from "./ModalBenefitDetail";

import useBenefitsStore from "../state";

export const BenefitsContainer = ({ handleOpenModal }) => {
    const filteredBenefits = useBenefitsStore(
        (state) => state.filteredBenefits
    );

    return (
        <div className='benefits-container'>
            {filteredBenefits.map((benefit) => (
                <BenefitCard
                    key={benefit.id}
                    benefit={benefit}
                    handleClick={() => handleOpenModal(benefit)}
                />
            ))}
        </div>
    );
};
